var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.066,
    height: 28,
    viewBox: "0 0 33.066 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "transfer",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1204",
    "data-name": "Pfad 1204",
    d: "M350.893,795.914H337.946a3.172,3.172,0,0,1-3.17-3.167V781.021l-.034.021a3.173,3.173,0,0,1-4.327-1.16l-2.083-3.6a3.167,3.167,0,0,1,1.16-4.323l6.126-3.532a3.71,3.71,0,0,1,1.877-.51h2.2a1.2,1.2,0,0,1,1.073.664,4.083,4.083,0,0,0,7.3,0,1.2,1.2,0,0,1,1.073-.664h2.2a3.721,3.721,0,0,1,1.96.559l6.091,3.512a3.161,3.161,0,0,1,1.159,4.322l-2.083,3.6a3.177,3.177,0,0,1-4.331,1.157l-.073-.045v11.724A3.173,3.173,0,0,1,350.893,795.914Zm-14.916-18.16a1.2,1.2,0,0,1,1.2,1.2v13.793a.769.769,0,0,0,.768.77h12.947a.77.77,0,0,0,.768-.77V778.954a1.2,1.2,0,0,1,1.8-1.038l1.876,1.075a.774.774,0,0,0,1.055-.279l2.082-3.6a.77.77,0,0,0-.28-1.051l-6.123-3.53a1.357,1.357,0,0,0-.728-.217h-1.505a6.487,6.487,0,0,1-10.83,0H337.5a1.3,1.3,0,0,0-.67.181l-6.133,3.539a.771.771,0,0,0-.282,1.052l2.083,3.6a.772.772,0,0,0,1.05.282l1.835-1.05A1.182,1.182,0,0,1,335.976,777.754Z",
    transform: "translate(-327.909 -767.914)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Pfad_1571",
    "data-name": "Pfad 1571",
    transform: "translate(11.032 7.187)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8 10 L 3 10 C 1.897199988365173 10 1 9.102800369262695 1 8 L 1 3 C 1 1.897199988365173 1.897199988365173 1 3 1 L 6.686450958251953 1 L 10 4.345940589904785 L 10 8 C 10 9.102800369262695 9.102800369262695 10 8 10 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3 2 C 2.448599815368652 2 2 2.448599815368652 2 3 L 2 8 C 2 8.551400184631348 2.448599815368652 9 3 9 L 8 9 C 8.551400184631348 9 9 8.551400184631348 9 8 L 9 4.75731086730957 L 6.269382476806641 2 L 3 2 M 3 0 L 7.103519916534424 0 L 11 3.934569835662842 L 11 8 C 11 9.65684986114502 9.65684986114502 11 8 11 L 3 11 C 1.34315013885498 11 0 9.65684986114502 0 8 L 0 3 C 0 1.34315013885498 1.34315013885498 0 3 0 Z",
    stroke: "none",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Differenzmenge_19",
    "data-name": "Differenzmenge 19",
    d: "M5,7H2A2,2,0,0,1,0,5V2A2,2,0,0,1,2,0h.333V4.667H7V5A2,2,0,0,1,5,7Z",
    transform: "translate(14.499 7.188)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer);
export default __webpack_public_path__ + "static/media/transfer.648cad2f14c22204cbb6242e854abadb.svg";
export { ForwardRef as ReactComponent };